import { render, staticRenderFns } from "./VTooltip.vue?vue&type=template&id=47de4caa"
import script from "./VTooltip.vue?vue&type=script&lang=js"
export * from "./VTooltip.vue?vue&type=script&lang=js"
import style0 from "./VTooltip.vue?vue&type=style&index=0&id=47de4caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports